module.exports = __webpack_public_path__ + "img/img38.b4a57b71.png";